<template>
    <v-card>
        <h3 class="text-md-center font-weight-black" style="text-decoration: underline;">
            {{$storeCandidature.langueFormulaire == 'en' ? 'Step' : 'Etape'}} {{etape}}:{{$storeCandidature.langueFormulaire == 'en' ? ' Supporting Documents' : ' Pièces à joindre'}}
        </h3>
        <p class="mt-3 ml-2 text-xs-left title teal--text text--darken-2" v-if="!$storeCandidature.configurationClient.ParamFormulaire.AjoutPJNonObligatoire && !$storeCandidature.configurationClient.ParamFormulaire.ValidationPJNonObligatoire">
            {{$storeCandidature.langueFormulaire == 'en' ? 'Your supporting documents must be validated by the admissions department in order to finalize the application.' : 'Vos pièces justificatives doivent être validées par le service des admissions pour pouvoir finaliser la candidature.'}}
        </p>
        <p class="mt-3 ml-2 text-xs-left title teal--text text--darken-2" v-if="!$storeCandidature.configurationClient.ParamFormulaire.AjoutPJNonObligatoire && $storeCandidature.configurationClient.ParamFormulaire.ValidationPJNonObligatoire">
            {{$storeCandidature.langueFormulaire == 'en' ? 'All supporting documents must be uploaded to finalize the application.' : 'Tous les fichiers doivent être fournis pour pouvoir finaliser la candidature.'}}
        </p>
        <p class="mt-3 ml-2 text-xs-left title teal--text text--darken-2" v-if="$storeCandidature.configurationClient.ParamFormulaire.AjoutPJNonObligatoire && $storeCandidature.configurationClient.ParamFormulaire.ValidationPJNonObligatoire">
            {{$storeCandidature.langueFormulaire == 'en' ? 'Supporting documents.' : 'Liste des pièces jointes.'}}
        </p>
        <v-data-table :headers="headerPiecesJustificatives" :items="$storeCandidature.sasCandidature.ListePiecesJustificatives" class="elevation-1 ma-2" disable-pagination hide-default-footer>
            <template v-slot:no-data>
                <v-alert :value="true" color="red lighten-1" icon="warning">{{$storeCandidature.langueFormulaire == 'en' ? 'The list is empty (Mandatory)' : 'La liste est vide (Renseignement obligatoire)'}}</v-alert>
            </template>
            <template v-slot:item={item}>
                <tr v-if="!item.Supprimer" v-bind:class="[!item.NomPieceJointe && !$storeCandidature.configurationClient.ParamFormulaire.AjoutPJNonObligatoire ? 'red--text' : 'black--text']">
                    <th class="text-xs-left">{{item.Type ? ($storeCandidature.langueFormulaire == 'en' ? item.Type.Lang01 : item.Type.Lang00): ''}}</th>
                    <th class="text-xs-left">{{item.NomPieceJointe}}</th>
                    <th>
                        <v-icon color="info" :title="$storeCandidature.langueFormulaire == 'en' ? 'OpenFile' : 'Afficher le document'"
                                @click="$storeCandidature.afficherAnnexe(item.UrlFichier)"
                                :disabled="!item.UrlFichier">
                            visibility
                        </v-icon>
                    </th>
                </tr>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
    export default {
        props: {
            etape: {
                default: 4
            }
        },
        data() {
            return {
                // Header Pièce justificatives
                headerPiecesJustificatives: [
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Attachment type' : 'Type de pièce', value: 'type' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'File' : 'Fichier', value: 'fichier' },
                    { text: '', value: '' }
                ],
            }
        }
    }
</script>

<style scoped>
</style>